
import HeaderB from '@/components/HeaderB/HeaderB.vue'
import FooterB from '@/components/FooterB/FooterB.vue'
import wsManager from '@/utils/websocket'
export default {
  components: {
    HeaderB,
    FooterB
  },

  data() {
    return {
      screen: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth
      },
      back:'',
      menus:[

      ],
      value: "",
      showmsg: "222",
      proxy: {},
      connectionAll:null,
      hubProxyAll:null,
      mesFlag:'',
    }
  },
  methods: {
    connectServer() {
      var $this = this;
      var userCode = localStorage.getItem('UserCode');
      var userId = localStorage.getItem('UserId');
      $this.connectionAll = $.hubConnection(SZH.assets.ws, {});
      $this.hubProxyAll = $this.connectionAll.createHubProxy("NoticeHub");
      $this.toGetMes();
      $this.connectionAll.start().done((connection) => {
        // $this.ClientId = connection.id;
        $this.hubProxyAll.invoke('Join', userCode,userId);
      }).fail((data) => {
      });
    },
    toGetMes() {
      var $this = this;
      $this.hubProxyAll.on("receiveMessage", (data) => {
        console.log(data);
        $this.mesFlag = data + new Date().toLocaleTimeString()
        if(data){
          $this.$notify({
            title: '系统消息',
            dangerouslyUseHTMLString: true,
            message: data,
            position: 'bottom-right'
          });
        }
      });
    },
    JumpTo(item){
      this.$router.push({
        path:item.url
      });
    },

  },
  beforeDestroy(){
    // if (this.connection) {
    //   try {
    //     this.connection.stop();
    //     console.log('SignalR顶级连接已关闭');
    //   } catch (error) {
    //     console.error('关闭连接失败:', error);
    //   }
    // }
  },
  created() {
    // wsManager.connectIfNeeded();
  },
  mounted() {
    // setTimeout(()=>{
    //   this.connectServer();
    // },1000);
    const self = this;
    window.onresize = () => {
      return (() => {
        self.screen = {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth
        }
      })();
    }
  },
  computed: {
    view() {
      return {
        height: this.screen.height,
        width: this.screen.width
      }
    },
  },
  watch: {
    $route(val) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeLay/HomeLay.js